module.exports = __webpack_public_path__ + "img/no-photo-crane.9157bc3c.png";